import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { startupCompanyData } from '../../components/Tab/TabData';

import Pagination from 'react-js-pagination';
import useScreenSize from '../../hooks/useScreenSize';

import { fetchGet } from '../../hooks/fetch';
import defaultLogo from "./hospital-startup-default.png";
import Loading from '../Loading';

export default function HospitalStartup() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const [posts, setPosts] = useState([]); // 전체 게시글 데이터
	const [page, setPage] = useState(1); // 현재 페이지 번호
	const [pagingInfo, setPagingInfo] = useState({});

	const postPerPage = 12; // 페이지 당 게시글 갯수

	const handlePageChange = (page) => {
		setPage(page);
	};

	const screenSize = useScreenSize();

	function getPage() {
		fetchGet(
			`/hospitalstartup`,
			(json) => {
				setPosts(json.dataList);
				setPagingInfo(json.pagingInfo);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getPage();
	}, []);

	const pageName = '병원 창업기업';

	return (
		<main id="startup-company-page-wrap" className="map-page">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={startupCompanyData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div className="gs-chunk-list-con">
							{isLoading ? <Loading /> : pagingInfo?.totalCount === 0 ? (
								<ul>
									<li>
										<div className="gs-no-con">등록된 내용이 없습니다.</div>
									</li>
								</ul>
							) : (
									<ul>
										{posts?.map((post, i) => (
											<li key={i}>
												{post.url !== "" ?
													<Link to={post.url} target="_blank">
														<div className="thumb">
															<img
																src={post?.thumbnail === null ? defaultLogo : `/api-tlo/file/image/${post.thumbnail}`}
																alt={`${post.name} 로고`}
															/>
														</div>
														<strong>{post.name}</strong>
													</Link>
													:
													<Link>
														<div className="thumb">
															<img
																src={post?.thumbnail === null ? defaultLogo : `/api-tlo/file/image/${post.thumbnail}`}
																alt={`${post.name} 로고`}
															/>
														</div>
														<strong>{post.name}</strong>
													</Link>
												}
											</li>
										))}
									</ul>
								)
							}
						</div>

						{pagingInfo?.totalCount > 0 && (
							<Pagination
								innerClass="gs-pagination"
								// itemClass="pg-item"
								linkClass="btn"
								itemClassFirst="pg-arrow pg-first"
								itemClassPrev="pg-arrow pg-prev"
								itemClassNext="pg-arrow pg-next"
								itemClassLast="pg-arrow pg-last"
								firstPageText={null} // 첫 번째 페이지 탐색 버튼의 텍스트
								prevPageText={null} // 이전 페이지 탐색 버튼의 텍스트
								nextPageText={null} // 다음 페이지 탐색 버튼의 텍스트
								lastPageText={null} // 마지막 페이지 탐색 버튼의 텍스트
								activePage={page} // 현재 페이지
								totalItemsCount={pagingInfo.totalCount} // 총 아이템 갯수
								itemsCountPerPage={postPerPage} // 한 페이지랑 보여줄 아이템 갯수
								pageRangeDisplayed={screenSize.width >= 480 ? 5 : 3} // paginator의 페이지 범위 (useScreenSize custom hook 사용)
								onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
							/>
						)}
					</div>
				</div>
			</Container>
		</main>
	);
}
